import React from 'react';

const UsdRewardsIcon = () => {
  return (
    <svg
      width={118}
      height={150}
      viewBox="0 0 118 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.7549 67.8319C36.5194 67.7637 30.8554 66.0841 21.5604 58.1634C11.9529 49.9788 11.6464 36.4633 11.639 35.8926C11.6347 35.6621 11.676 35.4331 11.7605 35.2187C11.845 35.0043 11.9711 34.8088 12.1315 34.6434C12.2918 34.478 12.4833 34.3461 12.6949 34.2552C12.9064 34.1642 13.1339 34.1161 13.3641 34.1136L29.8469 33.9194L29.8884 37.4136L15.2669 37.5855C15.6801 41.2768 17.3297 49.964 23.823 55.4964C32.4517 62.8479 37.673 64.4534 37.7248 64.4682L36.7549 67.8319Z"
        fill="#FCAB28"
      />
      <path
        d="M78.8263 67.8321L77.8667 64.4728C77.9096 64.4595 83.131 62.854 91.7596 55.5025C98.2529 49.9701 99.904 41.2844 100.316 37.5916L85.6942 37.4197L85.7357 33.9255L102.219 34.1197C102.449 34.1222 102.676 34.1703 102.888 34.2613C103.099 34.3522 103.291 34.4842 103.451 34.6495C103.612 34.8149 103.738 35.0104 103.822 35.2248C103.907 35.4392 103.948 35.6682 103.944 35.8987C103.935 36.4694 103.628 49.9819 94.0223 58.1695C84.7258 66.0902 79.0617 67.7698 78.8263 67.8321Z"
        fill="#FCAB28"
      />
      <path
        d="M29.0901 34.1254C29.0901 34.1254 26.9548 33.3486 26.9548 31.2153C26.9548 29.0821 26.5683 28.1022 28.5066 26.1676C30.445 24.233 45.1198 21.572 56.9484 21.572C68.7771 21.572 84.9356 24.8082 86.8769 26.556C88.8182 28.3038 88.0408 32.9617 87.6529 33.7385C87.2649 34.5153 85.713 34.3211 85.713 34.3211L29.0901 34.1254Z"
        fill="#FFCF3F"
      />
      <path
        d="M56.8213 28.1018C49.5194 28.1018 34.1324 29.0728 28.5083 33.1495C28.5083 33.1495 28.5083 54.1158 34.3264 64.7938C40.1445 75.4719 50.4212 84.2139 50.4212 84.2139H64.3837C64.3837 84.2139 74.662 75.4778 80.4786 64.7938C86.2952 54.1098 86.2966 33.1495 86.2966 33.1495C80.0921 29.0773 64.1231 28.1018 56.8213 28.1018Z"
        fill="#FFD733"
      />
      <path
        d="M56.8213 28.1018C49.5194 28.1018 34.1324 29.0728 28.5083 33.1495C28.5083 33.1495 28.5083 54.1158 34.3264 64.7938C37.0822 69.8519 40.8419 74.4727 44.0301 77.9372C46.4863 78.9658 49.1169 79.5129 51.7791 79.5486C69.6198 79.937 74.274 64.7938 76.2124 59.3577C79.2687 50.7936 81.0072 37.3463 81.6913 31.1052C74.1926 28.7378 62.7 28.1018 56.8213 28.1018Z"
        fill="#FFE266"
      />
      <path
        d="M77.3758 110.42C75.6299 105.178 71.9457 105.955 71.9457 105.955C71.9457 105.955 71.9457 104.27 69.3602 104.028C67.7624 103.536 63.6458 101.953 62.2524 98.383C60.505 93.9223 61.281 88.289 61.281 88.289L57.4027 87.782L53.523 88.289C53.523 88.289 54.299 93.9223 52.5546 98.383C51.1597 101.953 47.0416 103.536 45.4467 104.028C42.8672 104.27 42.8613 105.955 42.8613 105.955C42.8613 105.955 39.177 105.178 37.4312 110.42H77.3758Z"
        fill="#FFCE45"
      />
      <path
        d="M42.8589 105.956C45.2874 105.799 47.7115 105.692 50.1311 105.634C52.5552 105.571 54.9793 105.553 57.4033 105.546C59.8274 105.538 62.2515 105.569 64.6741 105.633C67.0967 105.697 69.5222 105.792 71.9463 105.95C69.5227 106.107 67.0986 106.213 64.6741 106.266C62.2515 106.331 59.8274 106.348 57.4033 106.355C54.9793 106.362 52.5552 106.33 50.1311 106.264C47.707 106.199 45.283 106.112 42.8589 105.956Z"
        fill="#FCAB28"
      />
      <path
        d="M64.3834 86.93H50.612C50.1996 86.93 49.8041 86.766 49.5125 86.4741C49.2209 86.1822 49.0571 85.7863 49.0571 85.3735C49.0571 84.9606 49.2209 84.5647 49.5125 84.2728C49.8041 83.9809 50.1996 83.8169 50.612 83.8169H64.3834C64.7958 83.8169 65.1913 83.9809 65.4829 84.2728C65.7745 84.5647 65.9383 84.9606 65.9383 85.3735C65.9383 85.7863 65.7745 86.1822 65.4829 86.4741C65.1913 86.766 64.7958 86.93 64.3834 86.93Z"
        fill="#FCAB28"
      />
      <path
        d="M63.608 88.8914H51.3884C51.0231 88.8914 50.6729 88.7461 50.4146 88.4876C50.1563 88.229 50.0112 87.8784 50.0112 87.5127C50.0112 87.1471 50.1563 86.7964 50.4146 86.5378C50.6729 86.2793 51.0231 86.134 51.3884 86.134H63.605C63.9702 86.134 64.3205 86.2793 64.5788 86.5378C64.8371 86.7964 64.9821 87.1471 64.9821 87.5127C64.9821 87.8784 64.8371 88.229 64.5788 88.4876C64.3205 88.7461 63.9702 88.8914 63.605 88.8914H63.608Z"
        fill="#FCAB28"
      />
      <path
        d="M79.2409 110.227H36.9225C35.4889 110.227 34.3267 111.39 34.3267 112.826V130.731C34.3267 132.166 35.4889 133.329 36.9225 133.329H79.2409C80.6745 133.329 81.8367 132.166 81.8367 130.731V112.826C81.8367 111.39 80.6745 110.227 79.2409 110.227Z"
        fill="#6C554F"
      />
      <path
        d="M72.1018 114.227H44.0613C43.3972 114.227 42.8589 114.765 42.8589 115.43V125.214C42.8589 125.879 43.3972 126.418 44.0613 126.418H72.1018C72.7659 126.418 73.3042 125.879 73.3042 125.214V115.43C73.3042 114.765 72.7659 114.227 72.1018 114.227Z"
        fill="#FCAB28"
      />
      <path
        d="M47.9258 114.232H57.5703C57.7984 114.232 57.9849 114.77 57.9849 115.434V125.218C57.9849 125.882 57.7984 126.422 57.5703 126.422H47.9258C47.6978 126.422 47.5127 125.882 47.5127 125.218V115.434C47.5127 114.764 47.6978 114.232 47.9258 114.232Z"
        fill="#FFD733"
      />
      <path
        d="M50.4209 84.2126C51.5848 84.1281 52.7487 84.0895 53.9112 84.0643C55.0736 84.0391 56.239 84.0213 57.4029 84.0169C58.5668 84.0124 59.7292 84.0273 60.8931 84.0643L62.6375 84.1207C63.2195 84.1533 63.8014 84.174 64.3834 84.22C63.8014 84.2659 63.2195 84.2852 62.6375 84.3193L60.8931 84.3756C59.7292 84.4127 58.5653 84.4171 57.4029 84.4216C56.2405 84.426 55.0751 84.4112 53.9112 84.3742C52.7472 84.3371 51.5848 84.2956 50.4209 84.2126Z"
        fill="#FFE266"
      />
      <path
        d="M50.4858 86.5411C51.6705 86.458 52.8551 86.418 54.0398 86.3854C55.2244 86.3528 56.4091 86.3439 57.5937 86.3394C58.7783 86.335 59.963 86.3483 61.1476 86.3854L62.9246 86.4417C63.5169 86.4758 64.1092 86.4951 64.7015 86.5411C64.1092 86.587 63.5169 86.6063 62.9246 86.6404L61.1476 86.6967C59.963 86.7338 58.7783 86.7397 57.5937 86.7442C56.4091 86.7486 55.2244 86.7338 54.0398 86.6967C52.8551 86.6597 51.6705 86.6256 50.4858 86.5411Z"
        fill="#FFE266"
      />
      <path
        d="M53.6592 89.1302C54.9018 88.9868 56.1519 88.9195 57.4026 88.9285C58.6529 88.9181 59.9027 88.9854 61.1446 89.1302C58.6568 89.401 56.147 89.401 53.6592 89.1302Z"
        fill="#FFE266"
      />
      <path
        d="M38.27 108.544C41.4587 108.383 44.6469 108.278 47.8345 108.228C51.0242 108.165 54.2123 108.147 57.402 108.14C60.5916 108.132 63.7798 108.163 66.968 108.228C70.1562 108.294 73.3458 108.387 76.5354 108.544C73.3458 108.701 70.1566 108.807 66.968 108.86C63.7798 108.925 60.5902 108.941 57.402 108.949C54.2138 108.956 51.0242 108.924 47.8345 108.858C44.6449 108.793 41.4582 108.701 38.27 108.544Z"
        fill="#FCAB28"
      />
      <g opacity="0.48">
        <path
          d="M47.0213 22.0886C43.7635 22.4059 40.6049 22.8462 37.8403 23.3472C37.519 32.9342 37.4168 48.9535 39.7653 57.8097C43.2437 71.0108 49.4513 77.6151 49.4513 77.6151C49.4513 77.6151 45.573 58.1951 45.961 41.1173C46.1476 32.9327 46.5992 26.5374 47.0213 22.0886Z"
          fill="#FFFFFD"
        />
      </g>
      <path
        d="M86.2966 33.1546C84.1495 31.9242 81.7669 31.22 79.3754 30.673C76.9747 30.1356 74.5479 29.7229 72.1046 29.4366C69.6613 29.1505 67.2091 28.9237 64.7524 28.7784C62.2958 28.6331 59.8362 28.5249 57.378 28.5145C54.9199 28.5042 52.4588 28.5738 50.0022 28.7117C47.5455 28.8496 45.0933 29.0571 42.65 29.3403C40.2063 29.6181 37.7792 30.0269 35.3792 30.5648C32.9922 31.1192 30.6081 31.8367 28.5083 33.1516C29.5151 32.4237 30.6096 31.826 31.7661 31.3727C32.0533 31.2571 32.3377 31.1311 32.6279 31.0243L33.5164 30.7278C34.1013 30.5173 34.701 30.3483 35.2933 30.1823C37.6895 29.5445 40.1227 29.0549 42.5789 28.7161C47.4872 28.0279 52.4382 27.6905 57.3943 27.7066C62.3493 27.751 67.2959 28.1215 72.2024 28.8155C74.657 29.1612 77.0889 29.6532 79.4849 30.289C80.0861 30.4373 80.6696 30.6374 81.2619 30.8272C81.8542 31.0169 82.4347 31.2333 83.0122 31.4572C83.5892 31.6811 84.1546 31.9339 84.7063 32.2147C84.9867 32.3455 85.257 32.4971 85.5148 32.6684L86.2966 33.1546Z"
        fill="#FCAB28"
      />
      <path
        d="M44.7507 37.4005L46.5617 34.2236L48.2558 37.4628L51.4306 39.2773L48.1936 40.9732L46.3826 44.1501L44.687 40.9095L41.5137 39.0979L44.7507 37.4005Z"
        fill="white"
      />
      <path
        d="M107.183 21.2374L108.994 18.0605L110.688 21.2997L113.863 23.1142L110.626 24.8101L108.815 27.987L107.12 24.7464L103.946 22.9348L107.183 21.2374Z"
        fill="white"
      />
      <path
        d="M13.9312 86.0268L15.2138 83.7791L16.4136 86.0709L18.6621 87.3548L16.3696 88.5547L15.0869 90.8025L13.8861 88.5096L11.6387 87.2278L13.9312 86.0268Z"
        fill="white"
      />
      <g opacity="0.35">
        <path d="M38.9331 133.329H46.1194L64.0683 110.227H55.8098L38.9331 133.329Z" fill="white" />
      </g>
      <g opacity="0.35">
        <path d="M56.6746 133.329L74.4768 110.227H71.102L53.1162 133.329H56.6746Z" fill="white" />
      </g>
      <g clipPath="url(#clip0_1931_44347)">
        <path
          d="M116.332 136.288H100.581C100.28 136.288 100.036 136.044 100.036 135.743V133.221C100.036 132.92 100.28 132.676 100.581 132.676H116.332C116.633 132.676 116.877 132.92 116.877 133.221V135.743C116.877 136.044 116.633 136.288 116.332 136.288Z"
          fill="url(#paint0_linear_1931_44347)"
        />
        <path
          d="M114.331 136.288H102.58C102.318 136.288 102.106 136.076 102.106 135.815V133.15C102.106 132.888 102.318 132.676 102.58 132.676H114.331C114.593 132.676 114.805 132.888 114.805 133.15V135.815C114.805 136.076 114.593 136.288 114.331 136.288Z"
          fill="url(#paint1_linear_1931_44347)"
        />
        <path
          d="M110.48 136.288H106.433C106.275 136.288 106.147 136.16 106.147 136.003V132.962C106.147 132.804 106.275 132.676 106.433 132.676H110.48C110.637 132.676 110.765 132.804 110.765 132.962V136.003C110.765 136.16 110.637 136.288 110.48 136.288Z"
          fill="url(#paint2_linear_1931_44347)"
        />
        <path
          d="M101.056 133.116C100.755 133.116 100.511 133.36 100.511 133.661V136.183C100.511 136.218 100.514 136.252 100.521 136.285C100.54 136.287 100.56 136.288 100.581 136.288H116.331C116.632 136.288 116.876 136.044 116.876 135.743V133.221C116.876 133.186 116.872 133.152 116.866 133.119C116.846 133.117 116.826 133.116 116.806 133.116H101.056Z"
          fill="url(#paint3_linear_1931_44347)"
        />
        <path
          d="M116.332 132.676H100.581C100.28 132.676 100.036 132.432 100.036 132.131V129.609C100.036 129.308 100.28 129.064 100.581 129.064H116.332C116.633 129.064 116.877 129.308 116.877 129.609V132.131C116.877 132.432 116.633 132.676 116.332 132.676Z"
          fill="url(#paint4_linear_1931_44347)"
        />
        <path
          d="M114.331 132.676H102.58C102.318 132.676 102.106 132.464 102.106 132.203V129.538C102.106 129.276 102.318 129.064 102.58 129.064H114.331C114.593 129.064 114.805 129.276 114.805 129.538V132.203C114.805 132.464 114.593 132.676 114.331 132.676Z"
          fill="url(#paint5_linear_1931_44347)"
        />
        <path
          d="M110.48 132.676H106.433C106.275 132.676 106.147 132.548 106.147 132.391V129.35C106.147 129.192 106.275 129.064 106.433 129.064H110.48C110.637 129.064 110.765 129.192 110.765 129.35V132.391C110.765 132.548 110.637 132.676 110.48 132.676Z"
          fill="url(#paint6_linear_1931_44347)"
        />
        <path
          d="M101.056 129.504C100.755 129.504 100.511 129.748 100.511 130.049V132.571C100.511 132.606 100.514 132.64 100.521 132.673C100.54 132.675 100.56 132.676 100.581 132.676H116.331C116.632 132.676 116.876 132.432 116.876 132.131V129.609C116.876 129.574 116.872 129.54 116.866 129.507C116.846 129.505 116.826 129.504 116.806 129.504H101.056Z"
          fill="url(#paint7_linear_1931_44347)"
        />
        <path
          d="M116.332 129.064H100.581C100.28 129.064 100.036 128.82 100.036 128.519V125.997C100.036 125.696 100.28 125.452 100.581 125.452H116.332C116.633 125.452 116.877 125.696 116.877 125.997V128.519C116.877 128.82 116.633 129.064 116.332 129.064Z"
          fill="url(#paint8_linear_1931_44347)"
        />
        <path
          d="M114.331 129.064H102.58C102.318 129.064 102.106 128.852 102.106 128.591V125.926C102.106 125.664 102.318 125.452 102.58 125.452H114.331C114.593 125.452 114.805 125.664 114.805 125.926V128.591C114.805 128.852 114.593 129.064 114.331 129.064Z"
          fill="url(#paint9_linear_1931_44347)"
        />
        <path
          d="M110.48 129.064H106.433C106.275 129.064 106.147 128.936 106.147 128.779V125.738C106.147 125.58 106.275 125.452 106.433 125.452H110.48C110.637 125.452 110.765 125.58 110.765 125.738V128.779C110.765 128.936 110.637 129.064 110.48 129.064Z"
          fill="url(#paint10_linear_1931_44347)"
        />
        <path
          d="M101.056 125.892C100.755 125.892 100.511 126.136 100.511 126.437V128.959C100.511 128.994 100.514 129.028 100.521 129.061C100.54 129.063 100.56 129.064 100.581 129.064H116.331C116.632 129.064 116.876 128.82 116.876 128.519V125.997C116.876 125.962 116.872 125.928 116.866 125.895C116.846 125.893 116.826 125.892 116.806 125.892H101.056Z"
          fill="url(#paint11_linear_1931_44347)"
        />
        <path
          d="M116.332 125.452H100.581C100.28 125.452 100.036 125.208 100.036 124.907V122.385C100.036 122.084 100.28 121.84 100.581 121.84H116.332C116.633 121.84 116.877 122.084 116.877 122.385V124.907C116.877 125.208 116.633 125.452 116.332 125.452Z"
          fill="url(#paint12_linear_1931_44347)"
        />
        <path
          d="M114.331 125.452H102.58C102.318 125.452 102.106 125.24 102.106 124.979V122.313C102.106 122.052 102.318 121.84 102.58 121.84H114.331C114.593 121.84 114.805 122.052 114.805 122.313V124.979C114.805 125.24 114.593 125.452 114.331 125.452Z"
          fill="url(#paint13_linear_1931_44347)"
        />
        <path
          d="M110.48 125.452H106.433C106.275 125.452 106.147 125.324 106.147 125.167V122.126C106.147 121.968 106.275 121.84 106.433 121.84H110.48C110.637 121.84 110.765 121.968 110.765 122.126V125.167C110.765 125.324 110.637 125.452 110.48 125.452Z"
          fill="url(#paint14_linear_1931_44347)"
        />
        <path
          d="M101.056 122.28C100.755 122.28 100.511 122.524 100.511 122.825V125.346C100.511 125.381 100.514 125.416 100.521 125.449C100.54 125.451 100.56 125.452 100.581 125.452H116.331C116.632 125.452 116.876 125.208 116.876 124.907V122.385C116.876 122.35 116.872 122.316 116.866 122.283C116.846 122.281 116.826 122.28 116.806 122.28H101.056Z"
          fill="url(#paint15_linear_1931_44347)"
        />
        <path
          d="M116.332 121.84H100.581C100.28 121.84 100.036 121.596 100.036 121.295V118.773C100.036 118.472 100.28 118.228 100.581 118.228H116.332C116.633 118.228 116.877 118.472 116.877 118.773V121.295C116.877 121.596 116.633 121.84 116.332 121.84Z"
          fill="url(#paint16_linear_1931_44347)"
        />
        <path
          d="M114.331 121.84H102.58C102.318 121.84 102.106 121.628 102.106 121.367V118.701C102.106 118.44 102.318 118.228 102.58 118.228H114.331C114.593 118.228 114.805 118.44 114.805 118.701V121.367C114.805 121.628 114.593 121.84 114.331 121.84Z"
          fill="url(#paint17_linear_1931_44347)"
        />
        <path
          d="M110.48 121.84H106.433C106.275 121.84 106.147 121.712 106.147 121.555V118.513C106.147 118.356 106.275 118.228 106.433 118.228H110.48C110.637 118.228 110.765 118.356 110.765 118.513V121.555C110.765 121.712 110.637 121.84 110.48 121.84Z"
          fill="url(#paint18_linear_1931_44347)"
        />
        <path
          d="M101.056 118.667C100.755 118.667 100.511 118.911 100.511 119.213V121.734C100.511 121.769 100.514 121.804 100.521 121.837C100.54 121.839 100.56 121.84 100.581 121.84H116.331C116.632 121.84 116.876 121.596 116.876 121.295V118.773C116.876 118.738 116.872 118.704 116.866 118.671C116.846 118.669 116.826 118.667 116.806 118.667H101.056Z"
          fill="url(#paint19_linear_1931_44347)"
        />
        <path
          d="M116.332 118.228H100.581C100.28 118.228 100.036 117.984 100.036 117.683V115.161C100.036 114.86 100.28 114.616 100.581 114.616H116.332C116.633 114.616 116.877 114.86 116.877 115.161V117.683C116.877 117.984 116.633 118.228 116.332 118.228Z"
          fill="url(#paint20_linear_1931_44347)"
        />
        <path
          d="M114.331 118.228H102.58C102.318 118.228 102.106 118.016 102.106 117.755V115.089C102.106 114.828 102.318 114.616 102.58 114.616H114.331C114.593 114.616 114.805 114.828 114.805 115.089V117.755C114.805 118.016 114.593 118.228 114.331 118.228Z"
          fill="url(#paint21_linear_1931_44347)"
        />
        <path
          d="M110.48 118.228H106.433C106.275 118.228 106.147 118.1 106.147 117.943V114.901C106.147 114.744 106.275 114.616 106.433 114.616H110.48C110.637 114.616 110.765 114.744 110.765 114.901V117.943C110.765 118.1 110.637 118.228 110.48 118.228Z"
          fill="url(#paint22_linear_1931_44347)"
        />
        <path
          d="M101.056 115.055C100.755 115.055 100.511 115.299 100.511 115.601V118.122C100.511 118.157 100.514 118.191 100.521 118.225C100.54 118.227 100.56 118.228 100.581 118.228H116.331C116.632 118.228 116.876 117.984 116.876 117.683V115.161C116.876 115.126 116.872 115.092 116.866 115.059C116.846 115.057 116.826 115.055 116.806 115.055H101.056Z"
          fill="url(#paint23_linear_1931_44347)"
        />
        <path
          d="M116.332 114.616H100.581C100.28 114.616 100.036 114.372 100.036 114.071V111.549C100.036 111.248 100.28 111.004 100.581 111.004H116.332C116.633 111.004 116.877 111.248 116.877 111.549V114.071C116.877 114.372 116.633 114.616 116.332 114.616Z"
          fill="url(#paint24_linear_1931_44347)"
        />
        <path
          d="M114.331 114.616H102.58C102.318 114.616 102.106 114.404 102.106 114.143V111.477C102.106 111.216 102.318 111.004 102.58 111.004H114.331C114.593 111.004 114.805 111.216 114.805 111.477V114.143C114.805 114.404 114.593 114.616 114.331 114.616Z"
          fill="url(#paint25_linear_1931_44347)"
        />
        <path
          d="M110.48 114.616H106.433C106.275 114.616 106.147 114.488 106.147 114.331V111.29C106.147 111.132 106.275 111.004 106.433 111.004H110.48C110.637 111.004 110.765 111.132 110.765 111.29V114.331C110.765 114.488 110.637 114.616 110.48 114.616Z"
          fill="url(#paint26_linear_1931_44347)"
        />
        <path
          d="M101.056 111.443C100.755 111.443 100.511 111.687 100.511 111.988V114.51C100.511 114.545 100.514 114.579 100.521 114.613C100.54 114.615 100.56 114.616 100.581 114.616H116.331C116.632 114.616 116.876 114.372 116.876 114.071V111.549C116.876 111.514 116.872 111.48 116.866 111.447C116.846 111.445 116.826 111.443 116.806 111.443H101.056Z"
          fill="url(#paint27_linear_1931_44347)"
        />
        <path
          d="M116.332 111.004H100.581C100.28 111.004 100.036 110.76 100.036 110.459V107.937C100.036 107.636 100.28 107.392 100.581 107.392H116.332C116.633 107.392 116.877 107.636 116.877 107.937V110.459C116.877 110.76 116.633 111.004 116.332 111.004Z"
          fill="url(#paint28_linear_1931_44347)"
        />
        <path
          d="M114.331 111.004H102.58C102.318 111.004 102.106 110.792 102.106 110.531V107.865C102.106 107.604 102.318 107.392 102.58 107.392H114.331C114.593 107.392 114.805 107.604 114.805 107.865V110.531C114.805 110.792 114.593 111.004 114.331 111.004Z"
          fill="url(#paint29_linear_1931_44347)"
        />
        <path
          d="M110.48 111.004H106.433C106.275 111.004 106.147 110.876 106.147 110.719V107.678C106.147 107.52 106.275 107.392 106.433 107.392H110.48C110.637 107.392 110.765 107.52 110.765 107.678V110.719C110.765 110.876 110.637 111.004 110.48 111.004Z"
          fill="url(#paint30_linear_1931_44347)"
        />
        <path
          d="M101.056 107.832C100.755 107.832 100.511 108.076 100.511 108.377V110.898C100.511 110.933 100.514 110.968 100.521 111.001C100.54 111.003 100.56 111.004 100.581 111.004H116.331C116.632 111.004 116.876 110.76 116.876 110.459V107.937C116.876 107.902 116.872 107.868 116.866 107.835C116.846 107.833 116.826 107.832 116.806 107.832H101.056Z"
          fill="url(#paint31_linear_1931_44347)"
        />
        <path
          d="M108.136 120.607L106.689 113.016C105.609 107.354 100.659 103.259 94.8948 103.259H89.4643C83.7003 103.259 78.7497 107.354 77.6701 113.016L76.8495 117.32C76.0609 121.456 74.8003 125.502 72.915 129.267C72.3637 130.367 72.0743 131.622 72.1285 132.949C72.2854 136.788 75.6643 140.092 79.5062 140.167C79.5343 140.167 79.5624 140.168 79.5905 140.168C81.3336 140.183 83.0118 140.862 84.2341 142.105C85.6003 143.494 87.5006 144.355 89.6029 144.355C92.1544 144.355 94.4089 143.087 95.7718 141.146C96.2106 140.522 96.9302 140.167 97.6936 140.168H97.7069C98.0349 140.168 98.3572 140.144 98.6721 140.097C99.2661 140.009 99.867 140.161 100.357 140.507C101.683 141.445 103.326 141.966 105.093 141.877C108.876 141.685 111.962 138.657 112.219 134.878C112.312 133.518 112.043 132.229 111.499 131.097C109.904 127.775 108.827 124.227 108.136 120.607Z"
          fill="url(#paint32_radial_1931_44347)"
        />
        <path
          d="M79.6566 140.168C83.8181 140.168 87.1917 136.794 87.1917 132.633C87.1917 128.471 83.8181 125.098 79.6566 125.098C75.4951 125.098 72.1216 128.471 72.1216 132.633C72.1216 136.794 75.4951 140.168 79.6566 140.168Z"
          fill="url(#paint33_linear_1931_44347)"
        />
        <path
          d="M89.6029 144.355C93.7644 144.355 97.138 140.981 97.138 136.82C97.138 132.658 93.7644 129.285 89.6029 129.285C85.4414 129.285 82.0679 132.658 82.0679 136.82C82.0679 140.981 85.4414 144.355 89.6029 144.355Z"
          fill="url(#paint34_linear_1931_44347)"
        />
        <path
          d="M104.702 141.887C108.864 141.887 112.237 138.513 112.237 134.352C112.237 130.19 108.864 126.817 104.702 126.817C100.541 126.817 97.167 130.19 97.167 134.352C97.167 138.513 100.541 141.887 104.702 141.887Z"
          fill="url(#paint35_linear_1931_44347)"
        />
        <path
          d="M112.219 134.878C112.311 133.518 112.042 132.229 111.499 131.097C109.903 127.775 108.827 124.227 108.136 120.607L106.689 113.016C106.297 110.962 105.394 109.115 104.129 107.594C102.035 105.861 99.3553 104.835 96.4716 104.835H91.041C85.2772 104.835 80.3265 108.931 79.2469 114.593L78.4262 118.897C77.6376 123.033 76.377 127.079 74.4917 130.843C73.9405 131.944 73.651 133.198 73.7052 134.525C73.7669 136.036 74.3289 137.462 75.22 138.643C76.4464 139.567 77.9374 140.136 79.5059 140.167C79.5341 140.167 79.5622 140.167 79.5903 140.168C81.3333 140.183 83.0116 140.862 84.234 142.105C85.6002 143.494 87.5005 144.355 89.6028 144.355C92.1542 144.355 94.4088 143.086 95.7717 141.146C96.2105 140.521 96.9301 140.166 97.6935 140.168H97.7068C98.0348 140.168 98.357 140.144 98.672 140.097C99.266 140.009 99.8669 140.161 100.357 140.507C101.683 141.445 103.325 141.966 105.093 141.877C108.876 141.685 111.962 138.657 112.219 134.878Z"
          fill="url(#paint36_linear_1931_44347)"
        />
        <path
          d="M98.5347 123.27C98.307 122.688 98.0344 122.206 97.7164 121.824C97.398 121.442 96.9752 121.078 96.448 120.733C95.9204 120.388 95.4478 120.124 95.0297 119.942C94.6113 119.76 94.1024 119.551 93.5024 119.315V115.332C94.1568 115.387 94.7885 115.569 95.398 115.878C96.007 116.187 96.4388 116.341 96.6936 116.341C97.2208 116.341 97.6346 116.083 97.9346 115.565C98.2346 115.048 98.3846 114.549 98.3846 114.068C98.3846 113.618 98.2164 113.225 97.8801 112.887C97.5433 112.55 97.1028 112.297 96.5572 112.129C96.0117 111.96 95.4934 111.838 95.0025 111.763C94.5115 111.688 94.0112 111.642 93.5024 111.623V110.993C93.5024 110.825 93.3932 110.67 93.175 110.527C92.9568 110.385 92.7202 110.313 92.4658 110.313C92.1746 110.313 91.9292 110.381 91.7293 110.516C91.5291 110.651 91.4293 110.811 91.4293 110.996V111.705C89.8474 111.927 88.5425 112.511 87.5154 113.457C86.4877 114.403 85.9743 115.7 85.9743 117.351C85.9743 118.024 86.0923 118.637 86.3288 119.192C86.565 119.747 86.8378 120.201 87.1473 120.555C87.4562 120.91 87.8926 121.256 88.4564 121.592C89.0198 121.929 89.493 122.178 89.8748 122.342C90.2566 122.506 90.7749 122.715 91.4294 122.969V127.388C90.7203 127.261 89.9472 126.902 89.1111 126.311C88.2744 125.72 87.6833 125.424 87.3381 125.424C86.8471 125.424 86.4151 125.679 86.0425 126.188C85.6696 126.697 85.4834 127.206 85.4834 127.715C85.4834 128.607 86.0699 129.406 87.2427 130.116C88.4156 130.825 89.8108 131.207 91.4294 131.261V131.943C91.4294 132.143 91.5293 132.315 91.7294 132.461C91.9293 132.607 92.1747 132.68 92.4659 132.68C92.7202 132.68 92.9569 132.602 93.1751 132.448C93.3934 132.293 93.5025 132.125 93.5025 131.943V131.152C95.139 130.879 96.4435 130.234 97.4164 129.215C98.3891 128.197 98.8757 126.861 98.8757 125.206C98.8756 124.497 98.7619 123.852 98.5347 123.27ZM91.7021 118.66C90.5383 118.169 89.9564 117.596 89.9564 116.941C89.9564 116.16 90.5382 115.651 91.7021 115.414V118.66ZM93.2295 127.361V123.706C94.3384 124.233 94.8934 124.879 94.8934 125.642C94.8934 126.533 94.3384 127.106 93.2295 127.361Z"
          fill="url(#paint37_linear_1931_44347)"
        />
        <path
          d="M95.8802 103.259H88.4784L85.1109 96.8031C84.6138 95.8501 85.1814 94.688 86.2386 94.4942L88.4438 94.0899C90.9136 93.637 93.445 93.637 95.9147 94.0899L98.1199 94.4942C99.1772 94.688 99.7448 95.85 99.2476 96.8031L95.8802 103.259Z"
          fill="url(#paint38_linear_1931_44347)"
        />
        <path
          d="M93.4103 103.259H90.9486L89.8287 96.8031C89.6633 95.8501 89.8521 94.688 90.2037 94.4942L90.9372 94.0899C91.7585 93.637 92.6004 93.637 93.4219 94.0899L94.1553 94.4942C94.507 94.688 94.6957 95.85 94.5304 96.8031L93.4103 103.259Z"
          fill="url(#paint39_linear_1931_44347)"
        />
        <path
          d="M99.1362 95.1438C99.2805 95.3491 99.2079 95.6351 98.984 95.7486C97.9338 96.2827 96.692 96.2827 95.6419 95.7486L94.7135 95.2772C93.6634 94.7432 92.4214 94.7432 91.3713 95.2772L90.4441 95.7486C89.3939 96.2827 88.1521 96.2827 87.1019 95.7486L86.1307 95.2547C85.7905 95.0816 85.8539 94.567 86.229 94.4965C86.2323 94.4959 86.2354 94.4953 86.2386 94.4947L88.4438 94.0896C90.9131 93.6375 93.445 93.6375 95.9144 94.0896L98.1196 94.4947C98.5551 94.5741 98.907 94.8177 99.1362 95.1438Z"
          fill="url(#paint40_linear_1931_44347)"
        />
        <path
          d="M99.269 96.0487C99.3186 95.9284 99.3545 95.805 99.3809 95.6806C99.2359 95.1012 98.7714 94.6137 98.12 94.4942L95.9147 94.0899C93.445 93.637 90.9135 93.637 88.4439 94.0899L86.7991 94.3915C86.593 94.8852 86.5667 95.4976 86.7939 96.0487L89.7655 103.259H95.8802L97.868 99.4478L99.269 96.0487Z"
          fill="url(#paint41_linear_1931_44347)"
        />
        <path
          d="M92.1793 103.982C90.5749 103.982 89.0562 103.879 87.8116 103.687C87.4018 103.624 87.1268 103.233 87.2095 102.827C87.2864 102.449 87.6454 102.198 88.0266 102.256C89.1955 102.435 90.6659 102.536 92.1793 102.536C93.6927 102.536 95.1631 102.435 96.3321 102.256C96.7132 102.198 97.0722 102.449 97.1491 102.827C97.2318 103.233 96.9568 103.624 96.547 103.687C95.3024 103.879 93.7838 103.982 92.1793 103.982Z"
          fill="url(#paint42_linear_1931_44347)"
        />
        <path
          d="M83.5717 123.667C83.5142 123.427 83.3009 123.249 83.0439 123.249H81.0445H77.192H75.3511C74.6905 125.312 73.886 127.327 72.9146 129.267C72.3633 130.367 72.0738 131.622 72.128 132.949C72.2849 136.788 75.6639 140.092 79.5057 140.167C79.5339 140.167 79.562 140.168 79.5901 140.168C81.3331 140.183 83.0114 140.862 84.2338 142.105C85.6 143.494 87.5003 144.355 89.6026 144.355C92.1541 144.355 94.4086 143.087 95.7715 141.146C96.2103 140.522 96.9299 140.167 97.6933 140.168H97.7066C98.0346 140.168 98.3568 140.144 98.6718 140.097C99.2658 140.009 99.8667 140.161 100.357 140.507C100.413 140.547 100.471 140.585 100.528 140.624L83.5717 123.667Z"
          fill="url(#paint43_linear_1931_44347)"
        />
        <path
          d="M87.2698 123.835V125.506C87.2698 125.775 87.0524 125.992 86.7839 125.992H69.2482C68.9797 125.992 68.7622 125.775 68.7622 125.506V123.835C68.7622 123.567 68.9797 123.349 69.2482 123.349H86.7839C87.0524 123.349 87.2698 123.567 87.2698 123.835Z"
          fill="#FFCE00"
        />
        <path d="M71.4238 123.349H70.5127V125.992H71.4238V123.349Z" fill="#FCBF00" />
        <path d="M73.7734 123.349H72.8623V125.992H73.7734V123.349Z" fill="#FCBF00" />
        <path d="M76.1216 123.349H75.2104V125.992H76.1216V123.349Z" fill="#FCBF00" />
        <path d="M78.4717 123.349H77.5605V125.992H78.4717V123.349Z" fill="#FCBF00" />
        <path d="M80.8203 123.349H79.9092V125.992H80.8203V123.349Z" fill="#FCBF00" />
        <path d="M83.1699 123.349H82.2588V125.992H83.1699V123.349Z" fill="#FCBF00" />
        <path d="M85.5185 123.349H84.6074V125.992H85.5185V123.349Z" fill="#FCBF00" />
        <path
          d="M88.0711 131.763V133.435C88.0711 133.703 87.8536 133.921 87.5851 133.921H70.0494C69.781 133.921 69.5635 133.703 69.5635 133.435V131.763C69.5635 131.495 69.7809 131.277 70.0494 131.277H87.5852C87.8536 131.277 88.0711 131.495 88.0711 131.763Z"
          fill="#FFCE00"
        />
        <path d="M72.2251 131.278H71.314V133.921H72.2251V131.278Z" fill="#FCBF00" />
        <path d="M74.5747 131.278H73.6636V133.921H74.5747V131.278Z" fill="#FCBF00" />
        <path d="M76.9228 131.278H76.0117V133.921H76.9228V131.278Z" fill="#FCBF00" />
        <path d="M79.2724 131.278H78.3613V133.921H79.2724V131.278Z" fill="#FCBF00" />
        <path d="M81.6216 131.278H80.7104V133.921H81.6216V131.278Z" fill="#FCBF00" />
        <path d="M83.9712 131.278H83.0601V133.921H83.9712V131.278Z" fill="#FCBF00" />
        <path d="M86.3193 131.278H85.4082V133.921H86.3193V131.278Z" fill="#FCBF00" />
        <path
          d="M90.7875 134.407V136.078C90.7875 136.347 90.57 136.564 90.3015 136.564H72.7652C72.4968 136.564 72.2793 136.347 72.2793 136.078V134.407C72.2793 134.139 72.4967 133.921 72.7652 133.921H90.3016C90.57 133.921 90.7875 134.139 90.7875 134.407Z"
          fill="#FFCE00"
        />
        <path
          d="M88.0877 139.693V141.364C88.0877 141.633 87.8702 141.85 87.6017 141.85H70.066C69.7976 141.85 69.5801 141.633 69.5801 141.364V139.693C69.5801 139.425 69.7975 139.207 70.066 139.207H87.6018C87.8702 139.207 88.0877 139.425 88.0877 139.693Z"
          fill="#FFCE00"
        />
        <path d="M72.2417 139.207H71.3306V141.85H72.2417V139.207Z" fill="#FCBF00" />
        <path d="M74.5913 139.207H73.6802V141.85H74.5913V139.207Z" fill="#FCBF00" />
        <path d="M76.9394 139.207H76.0283V141.85H76.9394V139.207Z" fill="#FCBF00" />
        <path d="M79.289 139.207H78.3779V141.85H79.289V139.207Z" fill="#FCBF00" />
        <path d="M81.6382 139.207H80.7271V141.85H81.6382V139.207Z" fill="#FCBF00" />
        <path d="M83.9878 139.207H83.0767V141.85H83.9878V139.207Z" fill="#FCBF00" />
        <path d="M86.3359 139.207H85.4248V141.85H86.3359V139.207Z" fill="#FCBF00" />
        <path
          d="M89.6229 142.336V144.007C89.6229 144.275 89.4055 144.493 89.137 144.493H71.6007C71.3328 144.493 71.1147 144.275 71.1147 144.007V142.336C71.1147 142.067 71.3328 141.85 71.6007 141.85H89.137C89.4055 141.85 89.6229 142.067 89.6229 142.336Z"
          fill="#FFCE00"
        />
        <path d="M73.7768 141.85H72.8657V144.493H73.7768V141.85Z" fill="#FCBF00" />
        <path d="M76.126 141.85H75.2148V144.493H76.126V141.85Z" fill="#FCBF00" />
        <path d="M78.4751 141.85H77.564V144.493H78.4751V141.85Z" fill="#FCBF00" />
        <path d="M80.8242 141.85H79.9131V144.493H80.8242V141.85Z" fill="#FCBF00" />
        <path d="M83.1733 141.85H82.2622V144.493H83.1733V141.85Z" fill="#FCBF00" />
        <path d="M85.5229 141.85H84.6118V144.493H85.5229V141.85Z" fill="#FCBF00" />
        <path d="M87.8721 141.85H86.9609V144.493H87.8721V141.85Z" fill="#FCBF00" />
        <path
          d="M86.0893 137.049V138.72C86.0893 138.989 85.8718 139.206 85.6033 139.206H68.067C67.7991 139.206 67.5811 138.989 67.5811 138.72V137.049C67.5811 136.781 67.7991 136.563 68.067 136.563H85.6034C85.8718 136.564 86.0893 136.781 86.0893 137.049Z"
          fill="#FFCE00"
        />
        <path d="M70.2431 136.564H69.332V139.207H70.2431V136.564Z" fill="#FCBF00" />
        <path d="M72.5923 136.564H71.6812V139.207H72.5923V136.564Z" fill="#FCBF00" />
        <path d="M74.9414 136.564H74.0303V139.207H74.9414V136.564Z" fill="#FCBF00" />
        <path d="M77.291 136.564H76.3799V139.207H77.291V136.564Z" fill="#FCBF00" />
        <path d="M79.6396 136.564H78.7285V139.207H79.6396V136.564Z" fill="#FCBF00" />
        <path d="M81.9888 136.564H81.0776V139.207H81.9888V136.564Z" fill="#FCBF00" />
        <path d="M84.3379 136.564H83.4268V139.207H84.3379V136.564Z" fill="#FCBF00" />
        <path
          d="M85.7387 126.478V128.149C85.7387 128.417 85.5212 128.635 85.2527 128.635H67.7164C67.4479 128.635 67.2305 128.417 67.2305 128.149V126.478C67.2305 126.209 67.4479 125.992 67.7164 125.992H85.2528C85.5212 125.992 85.7387 126.209 85.7387 126.478Z"
          fill="#FFCE00"
        />
        <path d="M69.8926 125.992H68.9814V128.636H69.8926V125.992Z" fill="#FCBF00" />
        <path d="M72.2417 125.992H71.3306V128.636H72.2417V125.992Z" fill="#FCBF00" />
        <path d="M74.5913 125.992H73.6802V128.636H74.5913V125.992Z" fill="#FCBF00" />
        <path d="M76.9394 125.992H76.0283V128.636H76.9394V125.992Z" fill="#FCBF00" />
        <path d="M79.289 125.992H78.3779V128.636H79.289V125.992Z" fill="#FCBF00" />
        <path d="M81.6382 125.992H80.7271V128.636H81.6382V125.992Z" fill="#FCBF00" />
        <path d="M83.9878 125.992H83.0767V128.636H83.9878V125.992Z" fill="#FCBF00" />
        <path
          d="M86.7449 129.121V130.792C86.7449 131.06 86.5275 131.278 86.259 131.278H68.7233C68.4548 131.278 68.2373 131.06 68.2373 130.792V129.121C68.2373 128.853 68.4548 128.635 68.7233 128.635H86.259C86.5275 128.635 86.7449 128.853 86.7449 129.121Z"
          fill="#FFCE00"
        />
        <path d="M70.8999 128.635H69.9888V131.277H70.8999V128.635Z" fill="#FCBF00" />
        <path d="M73.2485 128.635H72.3374V131.277H73.2485V128.635Z" fill="#FCBF00" />
        <path d="M75.5981 128.635H74.687V131.277H75.5981V128.635Z" fill="#FCBF00" />
        <path d="M77.9468 128.635H77.0356V131.277H77.9468V128.635Z" fill="#FCBF00" />
        <path d="M80.2964 128.635H79.3853V131.277H80.2964V128.635Z" fill="#FCBF00" />
        <path d="M82.6455 128.635H81.7344V131.277H82.6455V128.635Z" fill="#FCBF00" />
        <path d="M84.9951 128.635H84.084V131.277H84.9951V128.635Z" fill="#FCBF00" />
        <path d="M75.165 133.884H74.2539V136.528H75.165V133.884Z" fill="#FCBF00" />
        <path d="M77.5146 133.884H76.6035V136.528H77.5146V133.884Z" fill="#FCBF00" />
        <path d="M79.8628 133.884H78.9517V136.528H79.8628V133.884Z" fill="#FCBF00" />
        <path d="M82.2124 133.884H81.3013V136.528H82.2124V133.884Z" fill="#FCBF00" />
        <path d="M84.5615 133.884H83.6504V136.528H84.5615V133.884Z" fill="#FCBF00" />
        <path d="M86.9111 133.884H86V136.528H86.9111V133.884Z" fill="#FCBF00" />
        <path d="M89.2593 133.884H88.3481V136.528H89.2593V133.884Z" fill="#FCBF00" />
        <path
          d="M117.415 139.457V141.094C117.415 141.357 117.202 141.57 116.939 141.57H99.765C99.5021 141.57 99.2891 141.357 99.2891 141.094V139.457C99.2891 139.195 99.502 138.981 99.765 138.981H116.939C117.202 138.981 117.415 139.194 117.415 139.457Z"
          fill="#FFCE00"
        />
        <path d="M101.895 138.98H101.003V141.569H101.895V138.98Z" fill="#FCBF00" />
        <path d="M104.196 138.98H103.304V141.569H104.196V138.98Z" fill="#FCBF00" />
        <path d="M106.496 138.98H105.604V141.569H106.496V138.98Z" fill="#FCBF00" />
        <path d="M108.798 138.98H107.905V141.569H108.798V138.98Z" fill="#FCBF00" />
        <path d="M111.097 138.98H110.205V141.569H111.097V138.98Z" fill="#FCBF00" />
        <path d="M113.399 138.98H112.507V141.569H113.399V138.98Z" fill="#FCBF00" />
        <path d="M115.699 138.98H114.807V141.569H115.699V138.98Z" fill="#FCBF00" />
        <path
          d="M116.302 142.046V143.682C116.302 143.945 116.089 144.158 115.826 144.158H98.6517C98.3894 144.158 98.1758 143.945 98.1758 143.682V142.046C98.1758 141.783 98.3893 141.57 98.6517 141.57H115.826C116.089 141.57 116.302 141.783 116.302 142.046Z"
          fill="#FFCE00"
        />
        <path d="M100.783 141.57H99.8906V144.158H100.783V141.57Z" fill="#FCBF00" />
        <path d="M103.084 141.57H102.191V144.158H103.084V141.57Z" fill="#FCBF00" />
        <path d="M105.385 141.57H104.492V144.158H105.385V141.57Z" fill="#FCBF00" />
        <path d="M107.685 141.57H106.793V144.158H107.685V141.57Z" fill="#FCBF00" />
        <path d="M109.985 141.57H109.093V144.158H109.985V141.57Z" fill="#FCBF00" />
        <path d="M112.287 141.57H111.395V144.158H112.287V141.57Z" fill="#FCBF00" />
        <path d="M114.588 141.57H113.695V144.158H114.588V141.57Z" fill="#FCBF00" />
        <path
          d="M115.457 136.869V138.505C115.457 138.768 115.244 138.981 114.981 138.981H97.807C97.5446 138.981 97.3311 138.768 97.3311 138.505V136.869C97.3311 136.606 97.5446 136.393 97.807 136.393H114.981C115.244 136.393 115.457 136.606 115.457 136.869Z"
          fill="#FFCE00"
        />
        <path d="M99.9382 136.393H99.0459V138.981H99.9382V136.393Z" fill="#FCBF00" />
        <path d="M102.239 136.393H101.347V138.981H102.239V136.393Z" fill="#FCBF00" />
        <path d="M104.54 136.393H103.647V138.981H104.54V136.393Z" fill="#FCBF00" />
        <path d="M106.841 136.393H105.948V138.981H106.841V136.393Z" fill="#FCBF00" />
        <path d="M109.14 136.393H108.248V138.981H109.14V136.393Z" fill="#FCBF00" />
        <path d="M111.441 136.393H110.549V138.981H111.441V136.393Z" fill="#FCBF00" />
        <path d="M113.743 136.393H112.851V138.981H113.743V136.393Z" fill="#FCBF00" />
      </g>
      <path
        d="M110.104 78.2796C109.039 78.9738 108.13 79.8882 107.442 80.9579C107.287 81.1984 106.929 81.1978 106.776 80.9567C106.091 79.8846 105.186 78.9669 104.123 78.2688C103.887 78.1139 103.888 77.7615 104.124 77.6074C105.189 76.9131 106.098 75.9988 106.787 74.929C106.941 74.6885 107.299 74.6891 107.452 74.9302C108.137 76.0024 109.042 76.9201 110.105 77.6182C110.341 77.7732 110.34 78.1255 110.104 78.2796Z"
        fill="url(#paint44_linear_1931_44347)"
      />
      <path
        d="M34.3915 6.37629C32.4514 7.63006 30.796 9.28139 29.5425 11.2134C29.2605 11.6478 28.61 11.6467 28.3296 11.2112C27.0832 9.27487 25.4338 7.61756 23.4983 6.35672C23.0687 6.07694 23.0698 5.44054 23.5005 5.16221C25.4406 3.90844 27.096 2.25711 28.3496 0.325085C28.6315 -0.109266 29.2821 -0.108179 29.5624 0.32726C30.8088 2.26363 32.4582 3.92094 34.3937 5.18178C34.8233 5.46174 34.8222 6.09796 34.3915 6.37629Z"
        fill="url(#paint45_linear_1931_44347)"
      />
      <g clipPath="url(#clip1_1931_44347)">
        <path
          d="M39.7381 99.7531V102.891C39.7381 103.395 39.3298 103.804 38.8256 103.804H5.89547C5.39136 103.804 4.98291 103.395 4.98291 102.891V99.7531C4.98291 99.249 5.39125 98.8406 5.89547 98.8406H38.8257C39.3298 98.8407 39.7381 99.249 39.7381 99.7531Z"
          fill="#FFCE00"
        />
        <path d="M9.98148 98.8406H8.27051V103.804H9.98148V98.8406Z" fill="#FCBF00" />
        <path d="M14.3936 98.8406H12.6826V103.804H14.3936V98.8406Z" fill="#FCBF00" />
        <path d="M18.8037 98.8406H17.0928V103.804H18.8037V98.8406Z" fill="#FCBF00" />
        <path d="M23.2159 98.8406H21.5049V103.804H23.2159V98.8406Z" fill="#FCBF00" />
        <path d="M27.627 98.8406H25.916V103.804H27.627V98.8406Z" fill="#FCBF00" />
        <path d="M32.0391 98.8406H30.3281V103.804H32.0391V98.8406Z" fill="#FCBF00" />
        <path d="M36.4493 98.8406H34.7383V103.804H36.4493V98.8406Z" fill="#FCBF00" />
        <path
          d="M39.7381 114.642V117.781C39.7381 118.285 39.3298 118.693 38.8256 118.693H5.89547C5.39136 118.693 4.98291 118.285 4.98291 117.781V114.642C4.98291 114.139 5.39125 113.729 5.89547 113.729H38.8257C39.3298 113.729 39.7381 114.138 39.7381 114.642Z"
          fill="#FFCE00"
        />
        <path d="M9.98148 113.729H8.27051V118.693H9.98148V113.729Z" fill="#FCBF00" />
        <path d="M14.3936 113.729H12.6826V118.693H14.3936V113.729Z" fill="#FCBF00" />
        <path d="M18.8037 113.729H17.0928V118.693H18.8037V113.729Z" fill="#FCBF00" />
        <path d="M23.2159 113.729H21.5049V118.693H23.2159V113.729Z" fill="#FCBF00" />
        <path d="M27.627 113.729H25.916V118.693H27.627V113.729Z" fill="#FCBF00" />
        <path d="M32.0391 113.729H30.3281V118.693H32.0391V113.729Z" fill="#FCBF00" />
        <path d="M36.4493 113.729H34.7383V118.693H36.4493V113.729Z" fill="#FCBF00" />
        <path
          d="M44.8393 119.606V122.744C44.8393 123.248 44.431 123.656 43.9268 123.656H10.9956C10.4915 123.656 10.083 123.248 10.083 122.744V119.606C10.083 119.102 10.4913 118.693 10.9956 118.693H43.9269C44.431 118.693 44.8393 119.102 44.8393 119.606Z"
          fill="#FFCE00"
        />
        <path
          d="M39.7694 129.532V132.671C39.7694 133.175 39.361 133.583 38.8568 133.583H5.92672C5.42261 133.583 5.01416 133.175 5.01416 132.671V129.532C5.01416 129.029 5.4225 128.619 5.92672 128.619H38.8569C39.361 128.619 39.7694 129.029 39.7694 129.532Z"
          fill="#FFCE00"
        />
        <path d="M10.0127 128.619H8.30176V133.583H10.0127V128.619Z" fill="#FCBF00" />
        <path d="M14.4248 128.619H12.7139V133.583H14.4248V128.619Z" fill="#FCBF00" />
        <path d="M18.835 128.619H17.124V133.583H18.835V128.619Z" fill="#FCBF00" />
        <path d="M23.2471 128.619H21.5361V133.583H23.2471V128.619Z" fill="#FCBF00" />
        <path d="M27.6582 128.619H25.9473V133.583H27.6582V128.619Z" fill="#FCBF00" />
        <path d="M32.0703 128.619H30.3594V133.583H32.0703V128.619Z" fill="#FCBF00" />
        <path d="M36.4805 128.619H34.7695V133.583H36.4805V128.619Z" fill="#FCBF00" />
        <path
          d="M42.6528 134.495V137.633C42.6528 138.137 42.2445 138.546 41.7402 138.546H8.80905C8.30604 138.546 7.89648 138.137 7.89648 137.633V134.495C7.89648 133.991 8.30593 133.583 8.80905 133.583H41.7403C42.2445 133.583 42.6528 133.991 42.6528 134.495Z"
          fill="#FFCE00"
        />
        <path d="M12.8955 133.583H11.1846V138.546H12.8955V133.583Z" fill="#FCBF00" />
        <path d="M17.3067 133.583H15.5957V138.546H17.3067V133.583Z" fill="#FCBF00" />
        <path d="M21.7188 133.583H20.0078V138.546H21.7188V133.583Z" fill="#FCBF00" />
        <path d="M26.1299 133.583H24.4189V138.546H26.1299V133.583Z" fill="#FCBF00" />
        <path d="M30.5411 133.583H28.8301V138.546H30.5411V133.583Z" fill="#FCBF00" />
        <path d="M34.9532 133.583H33.2422V138.546H34.9532V133.583Z" fill="#FCBF00" />
        <path d="M39.3643 133.583H37.6533V138.546H39.3643V133.583Z" fill="#FCBF00" />
        <path
          d="M36.0166 124.569V127.707C36.0166 128.211 35.6082 128.619 35.104 128.619H2.17282C1.66981 128.619 1.26025 128.211 1.26025 127.707V124.569C1.26025 124.065 1.6697 123.656 2.17282 123.656H35.1041C35.6082 123.656 36.0166 124.065 36.0166 124.569Z"
          fill="#FFCE00"
        />
        <path d="M6.2598 123.656H4.54883V128.619H6.2598V123.656Z" fill="#FCBF00" />
        <path d="M10.6714 123.656H8.96045V128.619H10.6714V123.656Z" fill="#FCBF00" />
        <path d="M15.0826 123.656H13.3716V128.619H15.0826V123.656Z" fill="#FCBF00" />
        <path d="M19.4947 123.656H17.7837V128.619H19.4947V123.656Z" fill="#FCBF00" />
        <path d="M23.9048 123.656H22.1938V128.619H23.9048V123.656Z" fill="#FCBF00" />
        <path d="M28.3169 123.656H26.606V128.619H28.3169V123.656Z" fill="#FCBF00" />
        <path d="M32.7281 123.656H31.0171V128.619H32.7281V123.656Z" fill="#FCBF00" />
        <path
          d="M35.3584 104.716V107.855C35.3584 108.358 34.95 108.768 34.4458 108.768H1.51461C1.01039 108.768 0.602051 108.358 0.602051 107.855V104.716C0.602051 104.212 1.01039 103.803 1.51461 103.803H34.4459C34.95 103.803 35.3584 104.212 35.3584 104.716Z"
          fill="#FFCE00"
        />
        <path d="M5.60111 103.804H3.89014V108.768H5.60111V103.804Z" fill="#FCBF00" />
        <path d="M10.0122 103.804H8.30127V108.768H10.0122V103.804Z" fill="#FCBF00" />
        <path d="M14.4244 103.804H12.7134V108.768H14.4244V103.804Z" fill="#FCBF00" />
        <path d="M18.8345 103.804H17.1235V108.768H18.8345V103.804Z" fill="#FCBF00" />
        <path d="M23.2466 103.804H21.5356V108.768H23.2466V103.804Z" fill="#FCBF00" />
        <path d="M27.6577 103.804H25.9468V108.768H27.6577V103.804Z" fill="#FCBF00" />
        <path d="M32.0699 103.804H30.3589V108.768H32.0699V103.804Z" fill="#FCBF00" />
        <path
          d="M37.2484 109.68V112.816C37.2484 113.32 36.84 113.729 36.3358 113.729H3.40573C2.90161 113.729 2.49316 113.321 2.49316 112.816V109.68C2.49316 109.176 2.9015 108.767 3.40573 108.767H36.3359C36.84 108.767 37.2484 109.176 37.2484 109.68Z"
          fill="#FFCE00"
        />
        <path d="M7.49271 108.768H5.78174V113.729H7.49271V108.768Z" fill="#FCBF00" />
        <path d="M11.9038 108.768H10.1929V113.729H11.9038V108.768Z" fill="#FCBF00" />
        <path d="M16.316 108.768H14.605V113.729H16.316V108.768Z" fill="#FCBF00" />
        <path d="M20.7261 108.768H19.0151V113.729H20.7261V108.768Z" fill="#FCBF00" />
        <path d="M25.1382 108.768H23.4272V113.729H25.1382V108.768Z" fill="#FCBF00" />
        <path d="M29.5493 108.768H27.8384V113.729H29.5493V108.768Z" fill="#FCBF00" />
        <path d="M33.9615 108.768H32.2505V113.729H33.9615V108.768Z" fill="#FCBF00" />
        <path d="M15.0826 118.694H13.3716V123.657H15.0826V118.694Z" fill="#FCBF00" />
        <path d="M19.4947 118.694H17.7837V123.657H19.4947V118.694Z" fill="#FCBF00" />
        <path d="M23.9048 118.694H22.1938V123.657H23.9048V118.694Z" fill="#FCBF00" />
        <path d="M28.3169 118.694H26.606V123.657H28.3169V118.694Z" fill="#FCBF00" />
        <path d="M32.7281 118.694H31.0171V123.657H32.7281V118.694Z" fill="#FCBF00" />
        <path d="M37.1402 118.694H35.4292V123.657H37.1402V118.694Z" fill="#FCBF00" />
        <path d="M41.5503 118.694H39.8394V123.657H41.5503V118.694Z" fill="#FCBF00" />
        <path
          d="M43.9269 118.693H38.826C39.3301 118.693 39.7386 118.285 39.7386 117.78V114.641C39.7386 114.138 39.3302 113.729 38.826 113.729H36.336C36.8401 113.729 37.2484 113.32 37.2484 112.816V109.68C37.2484 109.176 36.8401 108.767 36.336 108.767H29.4123C18.7775 114.735 15.7737 128.885 23.1707 138.546H41.7403C42.2444 138.546 42.6528 138.137 42.6528 137.633V134.495C42.6528 133.991 42.2445 133.583 41.7403 133.583H38.8568C39.3609 133.583 39.7692 133.174 39.7692 132.67V129.531C39.7692 129.028 39.3609 128.619 38.8568 128.619H35.1041C35.6082 128.619 36.0167 128.21 36.0167 127.706V124.568C36.0167 124.064 35.6083 123.656 35.1041 123.656H43.9269C44.431 123.656 44.8395 123.247 44.8395 122.743V119.605C44.8394 119.101 44.431 118.693 43.9269 118.693Z"
          fill="#FFA81E"
        />
        <path
          d="M35.3584 104.716V105.514C35.3584 105.01 34.95 104.602 34.4458 104.602H1.51461C1.0105 104.602 0.602051 105.01 0.602051 105.514V104.716C0.602051 104.212 1.01039 103.803 1.51461 103.803H34.4459C34.95 103.803 35.3584 104.212 35.3584 104.716Z"
          fill="#FFA81E"
        />
        <path
          d="M37.249 109.68V110.478C37.249 109.974 36.8406 109.565 36.3364 109.565H3.40524C2.90113 109.565 2.49268 109.974 2.49268 110.478V109.68C2.49268 109.176 2.90101 108.767 3.40524 108.767H36.3365C36.8406 108.767 37.249 109.176 37.249 109.68Z"
          fill="#FFA81E"
        />
        <path
          d="M39.7387 114.642V115.44C39.7387 114.936 39.3304 114.527 38.8262 114.527H5.89498C5.39087 114.527 4.98242 114.936 4.98242 115.44V114.642C4.98242 114.137 5.39076 113.729 5.89498 113.729H38.8263C39.3304 113.729 39.7387 114.137 39.7387 114.642Z"
          fill="#FFA81E"
        />
        <path
          d="M44.8393 119.606V120.404C44.8393 119.9 44.431 119.492 43.9268 119.492H10.9956C10.4915 119.492 10.083 119.9 10.083 120.404V119.606C10.083 119.102 10.4913 118.693 10.9956 118.693H43.9269C44.431 118.693 44.8393 119.101 44.8393 119.606Z"
          fill="#FFA81E"
        />
        <path
          d="M36.0166 124.569V125.367C36.0166 124.863 35.6082 124.454 35.104 124.454H2.17282C1.6687 124.454 1.26025 124.863 1.26025 125.367V124.569C1.26025 124.064 1.66859 123.656 2.17282 123.656H35.1041C35.6082 123.656 36.0166 124.064 36.0166 124.569Z"
          fill="#FFA81E"
        />
        <path
          d="M39.7695 129.531V130.33C39.7695 129.826 39.3612 129.417 38.8569 129.417H5.92575C5.42163 129.417 5.01318 129.826 5.01318 130.33V129.531C5.01318 129.027 5.42152 128.619 5.92575 128.619H38.857C39.3612 128.619 39.7695 129.027 39.7695 129.531Z"
          fill="#FFA81E"
        />
        <path
          d="M42.6529 134.495V135.294C42.6529 134.79 42.2446 134.381 41.7403 134.381H8.80905C8.30493 134.381 7.89648 134.79 7.89648 135.294V134.495C7.89648 133.991 8.30482 133.583 8.80905 133.583H41.7403C42.2445 133.583 42.6529 133.991 42.6529 134.495Z"
          fill="#FFA81E"
        />
        <path
          d="M57.291 126.572C57.291 132.536 54.3742 137.818 49.8898 141.07C46.9413 143.209 43.3147 144.47 39.3939 144.47C29.5082 144.47 21.4956 136.457 21.4956 126.572C21.4956 116.687 29.5082 108.674 39.3939 108.674C43.0679 108.674 46.4839 109.781 49.3261 111.681C54.1286 114.89 57.291 120.361 57.291 126.572Z"
          fill="#FFCE00"
        />
        <path
          d="M39.3932 142.438C48.1559 142.438 55.2595 135.334 55.2595 126.571C55.2595 117.809 48.1559 110.705 39.3932 110.705C30.6304 110.705 23.5269 117.809 23.5269 126.571C23.5269 135.334 30.6304 142.438 39.3932 142.438Z"
          fill="#FFA81E"
        />
        <path
          d="M53.5831 126.572C53.5831 130.248 52.1852 133.598 49.8897 136.12C47.2954 138.971 43.5535 140.761 39.3938 140.761C31.5568 140.761 25.2036 134.408 25.2036 126.572C25.2036 118.735 31.5568 112.383 39.3938 112.383C42.108 112.383 44.6435 113.145 46.7985 114.467C50.8677 116.96 53.5831 121.449 53.5831 126.572Z"
          fill="#FFE571"
        />
        <path
          d="M39.3931 138.601C46.037 138.601 51.423 133.215 51.423 126.572C51.423 119.928 46.037 114.542 39.3931 114.542C32.7492 114.542 27.3633 119.928 27.3633 126.572C27.3633 133.215 32.7492 138.601 39.3931 138.601Z"
          fill="#FFCE00"
        />
        <path
          d="M39.393 136.366C44.8023 136.366 49.1874 131.981 49.1874 126.571C49.1874 121.162 44.8023 116.777 39.393 116.777C33.9837 116.777 29.5986 121.162 29.5986 126.571C29.5986 131.981 33.9837 136.366 39.393 136.366Z"
          fill="#FFE571"
        />
        <path
          d="M44.0744 128.648C44.0744 127.319 43.387 126.147 42.3497 125.469C42.7561 124.965 43.0002 124.326 43.0002 123.63C43.0002 122.227 42.0092 121.051 40.6904 120.765V120.17C40.6904 119.697 40.3074 119.314 39.835 119.314C39.3625 119.314 38.9795 119.697 38.9795 120.17V120.698H38.1557V119.478C38.1557 119.005 37.7727 118.622 37.3002 118.622C36.8278 118.622 36.4448 119.005 36.4448 119.478V120.698H35.5683C35.0959 120.698 34.7129 121.081 34.7129 121.554C34.7129 121.96 34.9957 122.299 35.3747 122.386L35.3752 130.757C34.9959 130.845 34.7129 131.184 34.7129 131.59C34.7129 132.062 35.0959 132.445 35.5683 132.445H36.4448V133.666C36.4448 134.139 36.8278 134.522 37.3002 134.522C37.7727 134.522 38.1557 134.139 38.1557 133.666V132.445H38.9795V132.974C38.9795 133.447 39.3625 133.829 39.835 133.829C40.3074 133.829 40.6904 133.447 40.6904 132.974V132.422C42.5905 132.216 44.0744 130.602 44.0744 128.648ZM41.2893 123.63C41.2893 124.303 40.7417 124.851 40.0685 124.851H37.0855L37.0854 122.409H40.0685C40.7415 122.409 41.2893 122.957 41.2893 123.63ZM40.2771 130.735H37.0859L37.0856 126.562H40.2771C41.4275 126.562 42.3634 127.498 42.3634 128.648C42.3634 129.799 41.4275 130.735 40.2771 130.735Z"
          fill="#FF8800"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1931_44347"
          x1="108.456"
          y1="132.751"
          x2="108.456"
          y2="137.434"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4F2FF" />
          <stop offset={1} stopColor="#B2CBFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1931_44347"
          x1="108.456"
          y1="132.819"
          x2="108.456"
          y2="140.695"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1931_44347"
          x1="108.456"
          y1="132.819"
          x2="108.456"
          y2="140.695"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1931_44347"
          x1="108.436"
          y1="134.08"
          x2="106.569"
          y2="129.565"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1931_44347"
          x1="108.456"
          y1="129.139"
          x2="108.456"
          y2="133.822"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4F2FF" />
          <stop offset={1} stopColor="#B2CBFF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1931_44347"
          x1="108.456"
          y1="129.207"
          x2="108.456"
          y2="137.083"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1931_44347"
          x1="108.456"
          y1="129.207"
          x2="108.456"
          y2="137.083"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1931_44347"
          x1="108.436"
          y1="130.468"
          x2="106.569"
          y2="125.953"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1931_44347"
          x1="108.456"
          y1="125.527"
          x2="108.456"
          y2="130.21"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4F2FF" />
          <stop offset={1} stopColor="#B2CBFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1931_44347"
          x1="108.456"
          y1="125.595"
          x2="108.456"
          y2="133.471"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1931_44347"
          x1="108.456"
          y1="125.595"
          x2="108.456"
          y2="133.471"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1931_44347"
          x1="108.436"
          y1="126.856"
          x2="106.569"
          y2="122.34"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1931_44347"
          x1="108.456"
          y1="121.915"
          x2="108.456"
          y2="126.598"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4F2FF" />
          <stop offset={1} stopColor="#B2CBFF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1931_44347"
          x1="108.456"
          y1="121.982"
          x2="108.456"
          y2="129.858"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1931_44347"
          x1="108.456"
          y1="121.982"
          x2="108.456"
          y2="129.858"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1931_44347"
          x1="108.436"
          y1="123.244"
          x2="106.569"
          y2="118.728"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1931_44347"
          x1="108.456"
          y1="118.302"
          x2="108.456"
          y2="122.986"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4F2FF" />
          <stop offset={1} stopColor="#B2CBFF" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1931_44347"
          x1="108.456"
          y1="118.37"
          x2="108.456"
          y2="126.246"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1931_44347"
          x1="108.456"
          y1="118.37"
          x2="108.456"
          y2="126.246"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1931_44347"
          x1="108.436"
          y1="119.632"
          x2="106.569"
          y2="115.116"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1931_44347"
          x1="108.456"
          y1="114.69"
          x2="108.456"
          y2="119.374"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4F2FF" />
          <stop offset={1} stopColor="#B2CBFF" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_1931_44347"
          x1="108.456"
          y1="114.758"
          x2="108.456"
          y2="122.634"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_1931_44347"
          x1="108.456"
          y1="114.758"
          x2="108.456"
          y2="122.634"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_1931_44347"
          x1="108.436"
          y1="116.02"
          x2="106.569"
          y2="111.504"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_1931_44347"
          x1="108.456"
          y1="111.079"
          x2="108.456"
          y2="115.762"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4F2FF" />
          <stop offset={1} stopColor="#B2CBFF" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_1931_44347"
          x1="108.456"
          y1="111.146"
          x2="108.456"
          y2="119.022"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_1931_44347"
          x1="108.456"
          y1="111.146"
          x2="108.456"
          y2="119.023"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_1931_44347"
          x1="108.436"
          y1="112.408"
          x2="106.569"
          y2="107.892"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_1931_44347"
          x1="108.456"
          y1="107.467"
          x2="108.456"
          y2="112.15"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4F2FF" />
          <stop offset={1} stopColor="#B2CBFF" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_1931_44347"
          x1="108.456"
          y1="107.534"
          x2="108.456"
          y2="115.41"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_1931_44347"
          x1="108.456"
          y1="107.534"
          x2="108.456"
          y2="115.41"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#3F3CED" stopOpacity={0} />
          <stop offset="0.2796" stopColor="#3C3DE4" stopOpacity="0.28" />
          <stop offset="0.7305" stopColor="#3541CC" stopOpacity="0.731" />
          <stop offset={1} stopColor="#2F43BB" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_1931_44347"
          x1="108.436"
          y1="108.796"
          x2="106.569"
          y2="104.28"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint32_radial_1931_44347"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(86.151 114.522) scale(33.8707 33.8707)">
          <stop stopColor="#4AB272" />
          <stop offset="0.3386" stopColor="#47B071" />
          <stop offset="0.5502" stopColor="#3FA870" />
          <stop offset="0.727" stopColor="#309B6D" />
          <stop offset="0.8837" stopColor="#1C8869" />
          <stop offset={1} stopColor="#077565" />
        </radialGradient>
        <linearGradient
          id="paint33_linear_1931_44347"
          x1="79.7349"
          y1="130.193"
          x2="78.6499"
          y2="164.012"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#005A01" stopOpacity={0} />
          <stop offset={1} stopColor="#005A01" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_1931_44347"
          x1="89.6124"
          y1="136.856"
          x2="94.4353"
          y2="155.263"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#005A01" stopOpacity={0} />
          <stop offset={1} stopColor="#005A01" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_1931_44347"
          x1="104.535"
          y1="136.495"
          x2="102.766"
          y2="159.162"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#005A01" stopOpacity={0} />
          <stop offset={1} stopColor="#005A01" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_1931_44347"
          x1="89.8264"
          y1="123.258"
          x2="67.1592"
          y2="82.7468"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#91F27F" stopOpacity={0} />
          <stop offset={1} stopColor="#FFED82" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_1931_44347"
          x1="88.8879"
          y1="118.387"
          x2="104.621"
          y2="131.951"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFC738" />
          <stop offset="0.1876" stopColor="#FDBF3C" />
          <stop offset="0.4837" stopColor="#F7A848" />
          <stop offset="0.8493" stopColor="#ED835B" />
          <stop offset={1} stopColor="#E97264" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_1931_44347"
          x1="90.3639"
          y1="92.2275"
          x2="95.669"
          y2="103.441"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#4AB272" />
          <stop offset="0.3386" stopColor="#47B071" />
          <stop offset="0.5502" stopColor="#3FA870" />
          <stop offset="0.727" stopColor="#309B6D" />
          <stop offset="0.8837" stopColor="#1C8869" />
          <stop offset={1} stopColor="#077565" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_1931_44347"
          x1="92.1066"
          y1="98.1465"
          x2="99.2603"
          y2="109.239"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#005A01" stopOpacity={0} />
          <stop offset={1} stopColor="#005A01" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_1931_44347"
          x1="92.4567"
          y1="94.1246"
          x2="92.8184"
          y2="97.6814"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#005A01" stopOpacity={0} />
          <stop offset={1} stopColor="#005A01" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_1931_44347"
          x1="90.8875"
          y1="98.5014"
          x2="77.2028"
          y2="98.2603"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#91F27F" stopOpacity={0} />
          <stop offset={1} stopColor="#FFED82" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_1931_44347"
          x1="92.1793"
          y1="102.546"
          x2="92.1793"
          y2="104.251"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFC738" />
          <stop offset="0.1876" stopColor="#FDBF3C" />
          <stop offset="0.4837" stopColor="#F7A848" />
          <stop offset="0.8493" stopColor="#ED835B" />
          <stop offset={1} stopColor="#E97264" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_1931_44347"
          x1="90.8562"
          y1="134.192"
          x2="80.2461"
          y2="133.308"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#005A01" stopOpacity={0} />
          <stop offset={1} stopColor="#005A01" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_1931_44347"
          x1="106.08"
          y1="76.5634"
          x2="109.432"
          y2="81.051"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD945" />
          <stop offset="0.3043" stopColor="#FFCD3E" />
          <stop offset="0.8558" stopColor="#FFAD2B" />
          <stop offset={1} stopColor="#FFA325" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_1931_44347"
          x1="27.063"
          y1="3.27685"
          x2="33.1015"
          y2="11.4302"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD945" />
          <stop offset="0.3043" stopColor="#FFCD3E" />
          <stop offset="0.8558" stopColor="#FFAD2B" />
          <stop offset={1} stopColor="#FFA325" />
        </linearGradient>
        <clipPath id="clip0_1931_44347">
          <rect
            width="51.1707"
            height="51.1707"
            fill="white"
            transform="translate(66.2271 93.7502)"
          />
        </clipPath>
        <clipPath id="clip1_1931_44347">
          <rect
            width="56.6892"
            height="56.6892"
            fill="white"
            transform="translate(0.602051 93.3108)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UsdRewardsIcon;
